import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { queryClient } from '#shared/api'
import doTgLogin from '#shared/lib/auth/do-tg-login.ts'
import doWebLogin from '#shared/lib/auth/do-web-login.ts'
import keycloak from '#shared/lib/auth/keycloak.ts'
import '#shared/lib/notifications'
import '#shared/styles/variables'
import router from './router.tsx'
import App from './ui/app.tsx'
import './ui/index.css'

router.options.context.queryClient = queryClient

async function main() {
  const rootEl = document.getElementById('root')
  if (!rootEl) {
    console.error('App root element not found')
    return
  }

  if (import.meta.env.PUBLIC_PLATFORM !== 'telegram') {
    await keycloak.init({ enableLogging: true })

    // Finish Keycloak login before any other router redirects if hash is present
    if (location.hash) {
      await doWebLogin()
    }
  }

  // Try to login immediatly if it's Telegram, due to lack of protected pages
  if (import.meta.env.PUBLIC_PLATFORM === 'telegram') {
    try {
      await doTgLogin()
    } catch {
      /* empty */
    }
  }

  const root = createRoot(rootEl)

  root.render(
    <QueryClientProvider client={queryClient}>
      <StrictMode>
        <App />
      </StrictMode>
    </QueryClientProvider>
  )
}

main()
